exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".bg___EO-Qy {\n  height: 100%;\n  background: #ffffff;\n  font-size: 14px;\n  padding: 20px 15px 0px 15px;\n}\n.date___20fPO {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  float: right;\n  text-align: right;\n}\n.date1___ROwpl {\n  margin-top: 10px;\n}\n.navigationBar___1u9UH {\n  height: 64px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n}\n.text1___2qKGH {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: center;\n      justify-content: center;\n  font-size: 18px;\n  font-weight: bold;\n  color: #151414;\n  margin-top: 50px;\n}\n.text2___22lLF {\n  font-weight: bold;\n  color: #151414;\n  text-decoration: underline;\n}\n.text3___1UNSC {\n  font-weight: bold;\n  text-decoration: underline;\n  color: #151414;\n}\n", ""]);

// exports
exports.locals = {
	"bg": "bg___EO-Qy",
	"date": "date___20fPO",
	"date1": "date1___ROwpl",
	"navigationBar": "navigationBar___1u9UH",
	"text1": "text1___2qKGH",
	"text2": "text2___22lLF",
	"text3": "text3___1UNSC"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[local]___[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/less-loader/dist/cjs.js?{"javascriptEnabled":true}!./src/routes/author/contract/authorAgreement.less
// module id = 1104
// module chunks = 0